@if (data | async; as item) {
  <div class="desktop_Outer_Wrapper">
    <div class="section_Wrapper">
      <div class="container blue_Container">
        <div class="headline" [innerHTML]="item.headLine1"></div>
      </div>
      <div class="card_Container">
        @for (item of cardsList; track item; let i = $index) {
          <div class="enhance_Card_Slides">
            <cx-media [alt]="item?.altText" [container]="item?.media" class="product_Logo"></cx-media>
            <div class="header1" [innerHTML]="item.header1"></div>
            <div class="sub_Text" [innerHTML]="item.PAgesubtext1"></div>
          </div>
        }
      </div>
    </div>
    <div class="bottom_Container">
      <div class="link_Container">
        <a [routerLink]="item.Pagesubtext2" class="sub_Page_Link">{{item.headLine3}}</a>
        <a [routerLink]="item.Pagesubtext1" class="sub_Page_Link">{{item.subheadline1}}</a>
      </div>
      <div class="headLine2" [innerHTML]="item.headLine2"></div>
      <div class="Pagetext1" [innerHTML]="item.Pagetext1"></div>
    </div>
  </div>
}